import React from "react";
import project1 from '../assets/images/project1.png';
import project2 from '../assets/images/project2.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://github.com/Joseph-Skinner/WAMTA_App" target="_blank" rel="noreferrer"><img src={project1} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/Joseph-Skinner/WAMTA_App" target="_blank" rel="noreferrer"><h2>WAMTA Companion</h2></a>
                <p>WIP native iOS app designed to more effectively traverse the Washington DC metro</p>
            </div>
            <div className="project">
                <a href="https://github.com/Joseph-Skinner/kanji_menu_bar_app" target="_blank" rel="noreferrer"><img src={project2} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/Joseph-Skinner/kanji_menu_bar_app" target="_blank" rel="noreferrer"><h2>Kanji Bar</h2></a>
                <p>WIP native MacOS menu bar app that aims to help Japanese language learners master new vocabulary </p>
            </div>
        </div>
    </div>
    );
}

export default Project;